export default {
  maintenanceHeading: { id: 'maintenance_heading' },
  maintenanceMessage: { id: 'maintenance_message' },
}
